import qs from 'qs'
import instance from '@/helpers/axios'
import moment from 'moment'
import numeral from 'numeral'
import groupArray from 'group-array'

const state = {
    transport_beginDate: null,
    transport_lastDate: null,
    transport_datasets: [],
    transport_state: [],
    get_airport: [],
    //v2
    transport_airport: [],
    transport_airport_filter: null,
    transport_isLoading: false,
    route_x_airport_destination_x_date: {},
    airport_destination: null,
    airport_selected: null,

    transport_table: null,
    transport_total: 0,
    transport_brand: [],
    transport_visit_type: [],
}

// getters
const getters = {
    transport_date: state => {
        if (state.transport_beginDate != null) {
            var _start = state.transport_beginDate.split("T");
            var _end = state.transport_lastDate.split("T")
            return { start: _start[0], end: _end[0] }
        } else {
            return { start: state.transport_beginDate, end: state.transport_lastDate }
        }
    },
    transport_isLoading: state => {
        return state.transport_isLoading;
    },
    transport_data_date: state => {
        if (state.transport_beginDate !== null) {
            var _start = state.transport_beginDate.split("T");
            var _end = state.transport_lastDate.split("T")
            return _start[0] + " to " + _end[0];
        } else {
            return "N/A"
        }
    },
    transport_datasets: state => {
        return state.transport_datasets;
    },
    transport_state: state => {
        return state.transport_state;
    },
    transport_airport: state => {
        return state.transport_airport;
    },
    transport_airport_filter: state => {
        return state.transport_airport_filter;
    },
    airport_destination: state => {
        if (state.airport_destination !== null) {
            var _airport = [];
            state.airport_destination.rows.forEach(function(item, index) {
                _airport.push(item._id.airport_destination);
            });
            _airport.sort(function(a, b) {
                return a.localeCompare(b)
            })
            return _airport;
        } else {
            return null;
        }
    },
    airport_selected: state => {
        return state.airport_selected;
    },
    transport_table: state => {
        return state.transport_table;
    },
}

// actions
const actions = {
    // start /v2 actions
    V2getTransportDatasets(context, payload) {
        state.transport_isLoading = true;
        state.transport_airport_filter = null;
        state.airport_selected = null;
        var _params = {};
        // calulate _params from main_filters                
        var main_filters = payload.main_filters;
        if (main_filters !== null) {
            if (main_filters.start !== null && main_filters.end !== null) {
                _params.start = new Date(main_filters.start).setUTCHours(0, 0, 0, 0);
                _params.end = new Date(main_filters.end).setUTCHours(23, 59, 59, 999);
            }
            if (main_filters.location_source !== null) {
                _params.location_source = main_filters.location_source;
            }
        }
        const request = {
            params: qs.parse(_params)
        };
        // query data
        instance.get('v2/market/transport', request)
            .then(response => {
                const {
                    date,
                    route_x_airport_destination_x_date,
                    airport_destination
                } = response.data;

                state.transport_beginDate = date.start;
                state.transport_lastDate = date.end;
                state.route_x_airport_destination_x_date = route_x_airport_destination_x_date;
                state.airport_destination = airport_destination;

                payload.stateDatasets.forEach(function(stateName) {
                    if (stateName == "transport_state") {
                        context.commit("V2onTransportState", payload);
                    }
                })
                state.transport_isLoading = false;
            })
            .catch(error => {
                console.log(error.response, "[store/v2/market/transport] syntax errors under instant.get");
            })

    },

    V2getTransportFilter(context, payload) {
        if (payload.airport !== undefined) {
            if (payload.airport !== null) {
                state.airport_selected = payload.airport;
                var rows = state.route_x_airport_destination_x_date.rows;
                var rows_filtered = [];
                rows.forEach(function(item, index) {
                    if (item._id.airport_destination == payload.airport) {
                        rows_filtered.push(item);
                    }
                });
                payload.rows_filtered = rows_filtered;
            } else {
                payload.rows_filtered = state.route_x_airport_destination_x_date.rows;
            }
            context.commit("V2onTransportState", payload);
        }
    },

    getTransportDatasets(context, payload) {
        // console.log("[store/market/transport] getTransportDatasets() DEPRECATED - excepted /transport/70");

        const request = {
            params: qs.parse({
                limit: 1,
                sort: "-date"
            })
        };
        instance.get('market/transport', request)
            .then(response => {
                const { rows } = response.data;
                const date = rows.map((item) => { return item.date });

                var _start = moment(new Date(date)).add(-7, 'days');
                var _end = moment(new Date(date));
                var _params = {
                    start: _start.format("YYYY-MM-DD"),
                    end: _end.format("YYYY-MM-DD"),
                    sort: '-date'
                };
                // calulate _params from main_filters                
                var main_filters = payload.main_filters;
                if (main_filters !== null) {
                    if (main_filters.start !== null && main_filters.end !== null) {
                        _start = moment(new Date(main_filters.start));
                        _end = moment(new Date(main_filters.end));
                        _params.start = _start.format("YYYY-MM-DD");
                        _params.end = _end.format("YYYY-MM-DD");
                    }
                    if (main_filters.location_source !== null) {
                        _params.location_source = main_filters.location_source;
                    }
                }

                // calulate _params from sub_filters
                // transport_brand, transport_visit_type q, limit, page, sort
                _params.limit = 5;
                _params.page = 1;
                var sub_filter = payload.sub_filter;
                if (sub_filter !== null) {
                    if (sub_filter.transport_brand !== null) {
                        _params.transport_brand = sub_filter.transport_brand;
                    }
                    if (sub_filter.transport_visit_type !== null) {
                        _params.transport_visit_type = sub_filter.transport_visit_type;
                    }

                    if (sub_filter.q !== "") {
                        _params.q = sub_filter.q;
                    }
                    if (sub_filter.limit > 0) {
                        _params.limit = sub_filter.limit;
                    }
                    if (sub_filter.page > 0) {
                        _params.page = sub_filter.page;
                    }
                    if (sub_filter.sort != "") {
                        _params.sort = sub_filter.sort;
                    }
                }

                state.transport_beginDate = moment(_start).format("YYYY-MM-DD");
                state.transport_lastDate = moment(_end).format("YYYY-MM-DD");

                const request = {
                    params: qs.parse(_params)
                };
                instance.get('market/transport', request)
                    .then(response => {
                        const { transport_brand, transport_visit_type, count, rows } = response.data;
                        state.transport_datasets = rows;
                        state.transport_total = count;
                        state.transport_brand = transport_brand;
                        state.transport_visit_type = transport_visit_type;
                        payload.stateDatasets.forEach(function(stateName) {
                            if (stateName == "transport_table") {
                                context.commit("onTransportTable", payload);
                            }
                        })
                    })
                    .catch(error => {
                        console.log(error.response, "[store/market/transport] syntax errors under instant.get");
                    })
            })
            .catch(error => {
                console.log(error.response);
            })
    },
}

// mutations
const mutations = {
    V2onTransportState(state, payload) {
        // --- start dataset for stack chart
        // items = [{label1:0,label2:0,...,date:string}]
        var total = 0;
        var colors = [];
        colors['เดินทางเข้า'] = '#3241a6';
        colors['เดินทางออก'] = '#578e47';

        var rows = state.route_x_airport_destination_x_date.rows;
        // on filtered load raw data from payload.rows_filtered
        if (payload.rows_filtered !== undefined) {
            rows = payload.rows_filtered;
        }

        var items = [];
        rows.forEach(function(item, index) {
            total += item.sum_in;
            var _item = {};

            var pos = items.map(function(e) {
                return e.date;
            }).indexOf(item._id.date);
            if (pos == -1) {
                _item['date'] = item._id.date;
                _item['เดินทางเข้า'] = item.sum_in;
                _item['เดินทางออก'] = item.sum_out;
                items.push(_item);
            } else {
                _item = items[pos];
                _item['เดินทางเข้า'] += item.sum_in;
                _item['เดินทางออก'] += item.sum_out;
                items[pos] = _item;
            }
        });

        // sort by date desc        
        items.sort(function(a, b) {
            var _a = parseInt(a.date.split("-").join(""));
            var _b = parseInt(b.date.split("-").join(""));
            return _a - _b;
        });

        // attached colors 
        items.push(colors);

        if (total == 0) {
            items = [];
        }

        // on filtered save items data to transport_airport_filter
        if (payload.rows_filtered !== undefined) {
            state.transport_airport_filter = items;
        } else {
            state.transport_airport = items;
        }

        // --- end dataset for stack chart
    },

    onTransportTable(state, payload) {
        // --- start dataset for v-data-table
        /**
        {
            "id": "5be5310df69c3b9b60f49e29",
            "transport_brand": "Emirates",
            "transport_flight": "EK419",
            "transport_seats": 517,
            "transport_visit_type": "Connected",
            "country_origin": "ออสเตรเลีย",
            "country_destination": "ไทย",
            "airport_origin": "Kingsford Smith",
            "airport_destination": "สุวรรณภูมิ",
            "date": "2019-04-01T00:00:00.000Z"
        }
        */
        var rows = state.transport_datasets;
        var transport_datatable = {
            headers: [
                { text: 'Date', value: "date", align: 'left', style: 'width:120px;' },
                { text: 'Brand', value: "transport_brand", align: 'left' },
                { text: 'Flight', value: "transport_flight", align: 'left' },
                { text: 'Seat', value: "transport_seats", align: 'left' },
                { text: 'Visit Type', value: "transport_visit_type", align: 'left' },
                { text: 'Country Origin', value: "country_origin", align: 'left' },
                { text: 'Airport Origin', value: "airport_origin", align: 'left' },
                { text: 'Country Destination', value: "country_destination", align: 'left' },
                { text: 'Airport Destination', value: "airport_destination", align: 'left' },
            ],
            items: [{
                value: false,
                date: '',
                transport_brand: '',
                transport_flight: '',
                transport_seats: '',
                transport_visit_type: '',
                country_origin: '',
                airport_origin: '',
                country_destination: '',
                airport_destination: '',
            }],
            pagination: {
                sortBy: 'date',
                descending: false,
            },
            total: 0,
        };

        // build items
        var items = [];
        rows.forEach(function(item, index) {
            var _item = {
                value: false,
                date: item.date,
                transport_brand: item.transport_brand,
                transport_flight: item.transport_flight,
                transport_seats: item.transport_seats,
                transport_visit_type: item.transport_visit_type,
                country_origin: item.country_origin,
                airport_origin: item.airport_origin,
                country_destination: item.country_destination,
                airport_destination: item.airport_destination,
            }
            items.push(_item);
        });
        transport_datatable.items = items;
        transport_datatable.total = state.transport_total;
        transport_datatable.transport_brand = state.transport_brand.sort(function(a, b) { return a.localeCompare(b) });
        transport_datatable.transport_visit_type = state.transport_visit_type.sort(function(a, b) { return a.localeCompare(b) });
        state.transport_table = transport_datatable;
        // --- start dataset for v-data-table
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}